import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

// Components
import OrderTable from '../OrderTableMX';
import OrderTotals from '../OrderTotals';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import OrderCard from '../OrderCard';
import AddressFormMX from '../AddressFormMX';
import Skeleton from '@mui/material/Skeleton';
import AlertMessage from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import SavedAddresses from '../SavedAddresses';
import Alert from '../Alert';

// Queries
import postGlobal from '../Queries/postGlobal';
import getPaqueterias from '../Queries/getPaqueterias';
import postPagos from '../Queries/postPagos';
import postActualizarDomicilio from '../Queries/postActualizarDomicilio';
import getReciclar from '../Queries/getReciclar';

// Styles
import styles from './index.module.sass';
import OrderClose from '../OrderClose';

export default function OrderDetailMX({
  history,
  match,
  getCookie,
  webservice,
  device,
  setSessionMessage,
}) {
  const [orderData, setOrderData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingAddress, setLoaddingAddress] = useState(false);
  const [finishLoading, setFinishLoading] = useState(false);
  const [openAddress, setOpenAddress] = useState(false);
  const { orderMessage = '' } = useParams();
  const [openMessage, setOpenMessage] = useState(orderMessage === 'error');
  const [addressSelected, setAddressSelected] = useState({ type: 'kit', pos: null, val: {} });
  const [paqueterias, setpaqueterias] = useState({});
  const [paqueteria, setpaqueteria] = useState('');
  const [greenBag, setGreenBag] = useState(false);
  const [showPayment, setshowPayment] = useState({
    cardPayment: false,
    paymentInStore: false,
    paymentInCash: false,
  });
  const { cliente = {}, domicilioEnvio = {}, totales = {} } = orderData;
  const { t } = useTranslation(['order', 'address']);
  const [form, setForm] = useState({
    payCard: false,
    paytotal: { name: '' },
    amount: '',
    kit: getCookie('usuarioOk'),
  });
  const [changeAddress, setChangeAddress] = useState('false');
  const [changePaq, setChangePaq] = useState('false');
  const [missingData, setMissingData] = useState('');
  const [exeptionCYC, setExeptionCYC] = useState('false');
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [typePayment, settypePayment] = useState('');

  const handleChange = (e, type) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const changeValue = (e) => {
    setpaqueteria(e.target.value);
    handleSubmit(e.target.value);
  };

  async function handleSubmit(paqueteriaEnviada) {
    setLoading(true);
    const response = await postActualizarDomicilio({
      jsonBody: {
        usuarioOK: getCookie('usuarioOk'),
        folioPedido: getCookie('folioPedido'),
        soloPaqueteria: 1,
        paqueteria: paqueteriaEnviada,
        cp: domicilioEnvio.cp,
      },
    });

    const { tipoMensaje = 'error', mensaje = '' } = response;
    setSessionMessage(mensaje);
    if (tipoMensaje === 'error') {
      setAlertText(mensaje);
      setOpen(true);
      if (mensaje === '498' || mensaje === '499') return false;
      setLoading(false);
      return false;
    } else {
      getOrder('CERRAR01', '', '', '', '', true, '');
    }
    setLoading(false);
  }

  const { screenSize } = device;

  const getOrder = useCallback(
    async (action, cat, id, quantity, lineNum, neddLoading, form) => {
      setLoading(neddLoading);
      const order = await postGlobal({
        tmbservice: 'getAgregarAlCarrito',
        jsonBody: {
          accion: action,
          usuarioOK: getCookie('usuarioOk'),
          folioPedido: getCookie('folioPedido'),
          almacen: getCookie('warehouse'),
          categoria: cat,
          clave: id,
          cantidad: quantity,
          numeroLinea: lineNum,
          textoProdSeleccion: '',
          idioma: 0,
          origen: 'CARRITONUE',
        },
      });

      if (action === 'CERRAR02') {
        if (order.mensaje === 'SE EJECUTO CIERRE DE PEDIDO') {
          //Guardar la Cookie pedido cerrado
          const now = new Date();
          const time = now.getTime();
          const expireTime = time + 1000 * 36000;
          now.setTime(expireTime);
          document.cookie = `pedidoCerrado=SI;expires=${now.toUTCString()};path=/`;
          switch (form.amount) {
            case 'card':
              if (form.paytotal <= 0) {
                setAlertText('El monto debe de ser mayor a 0.');
                setOpen(true);
                return;
              }
              async function paymentOpen(e) {
                const response = await postPagos(form);
                if (response.tipoMensaje === 'exito') {
                  window.open(
                    response.enlaceParaRedireccion,
                    '_blank',
                    'location=yes,height=570,width=520,scrollbars=yes,status=yes',
                  );
                } else {
                  setAlertText(response.mensaje);
                  setOpen(true);
                }
              }
              paymentOpen();
              break;
            case 'paycash':
              window.open(
                `https://www.terramarbrands.mx/wsterramar/Paycash.aspx?Kit=${getCookie(
                  'usuarioOk',
                )}`,
              );
              break;
            case 'cash':
              window.open('https://webimages.terramarbrands.com.mx/webpage/bancos.pdf');
              break;

            default:
              break;
          }
        } else {
          setAlertText(order.mensaje);
          setOpen(true);
        }
      }

      if (action === 'CERRAR01') {
        setChangeAddress(order.domicilioEnvio.bloquearCambioDomicilio || 'false');
        setChangePaq(order.domicilioEnvio.bloquearCambioPaqueteria || 'false');
        setMissingData(order.domicilioEnvio.faltanDatos || '');
        setExeptionCYC(order.domicilioEnvio.esExcepcionCyC || '');
        setpaqueteria(order.domicilioEnvio.paqueteria);
        setForm({
          paytotal: totales.importeAPagar,
          kit: getCookie('usuarioOk'),
          amount: typePayment,
        });
      }

      setOrderData(order || {});
      setLoading(false);
      setSessionMessage(order?.mensaje || '');
    },
    [getCookie, setSessionMessage, totales.importeAPagar, typePayment],
  );

  useEffect(() => {
    getOrder('CERRAR01', '', '', '', '', true, '');

    async function loadPaqueterias() {
      if (domicilioEnvio.cp !== undefined) {
        const response = await getPaqueterias(domicilioEnvio.cp);
        if (response.tipoMensaje === 'error') {
          setAlertText(response.mensaje);
          setOpen(true);
          return;
        } else {
          setpaqueterias(response.paqueterias);
          setSessionMessage(response.mensaje);
          if (response.cyc === '') {
            setExeptionCYC(false);
          } else {
            setExeptionCYC(true);
          }
        }
      }
    }
    loadPaqueterias();

    async function loadRecycle() {
      const response = await getReciclar('CONSULTAR', '');
      setSessionMessage(response.mensaje);
      if (response.tipoMensaje === 'exito') {
        if (response.seleccionado === 'N') {
          setGreenBag(true);
        } else {
          setGreenBag(false);
        }
      }
    }
    loadRecycle();
  }, [getOrder, getCookie, webservice, domicilioEnvio.cp, setSessionMessage, history]);

  async function handleClick() {
    setFinishLoading(true);
    let foundPaqueteria = '0';

    for (let index = 0; index < paqueterias.length; index++) {
      if (paqueteria === paqueterias[index].paqueteria) {
        foundPaqueteria = '1';
      }
    }

    if ((paqueteria === '' || foundPaqueteria === '0') && getCookie('warehouse') === '02') {
      setAlertText(t('shipping2'));
      setOpen(true);
      setFinishLoading(false);
      return;
    }

    if (!form.amount) {
      setAlertText(t('metodhPayment'));
      setOpen(true);
      setFinishLoading(false);
      return;
    }

    if (missingData !== '') {
      setAlertText(missingData);
      setOpen(true);
      return;
    } else {
      if (exeptionCYC === true) {
        setAlertText(t('alertCP'));
        setOpen(true);
        return;
      }
      getOrder('CERRAR02', '', '', '', '', true, form);

      setFinishLoading(false);
      window.scrollTo(0, 0);
    }
  }

  function greenBagSelect() {
    let nuevo_valor = greenBag === true ? 'S' : 'N';
    async function loadRecycle() {
      const response = await getReciclar('ESTABLECER', nuevo_valor);
      setSessionMessage(response.mensaje);
      if (response.tipoMensaje !== 'exito') {
        setAlertText(response.mensaje);
        setOpen(true);
        return;
      } else {
        if (response.seleccionado === 'N') {
          setGreenBag(true);
        } else {
          setGreenBag(false);
        }
      }
      setSessionMessage(response.mensaje);
    }
    loadRecycle();
  }

  function selectTypePayment(typePayment) {
    switch (typePayment) {
      case 'card':
        setshowPayment({ cardPayment: true });
        setForm({
          paytotal: totales.importeAPagar,
          kit: getCookie('usuarioOk'),
          amount: 'card',
        });
        break;
      case 'paycash':
        setshowPayment({ paymentInStore: true });
        setForm({
          paytotal: '',
          kit: '',
          amount: 'paycash',
        });
        break;
      case 'cash':
        setshowPayment({ paymentInCash: true });
        setForm({
          paytotal: '',
          kit: '',
          amount: 'cash',
        });
        break;
      default:
        break;
    }
    settypePayment(typePayment);
  }

  function cancel() {
    setshowPayment({ cardPayment: false });
    setForm({ paytotal: totales.importeAPagar, kit: getCookie('usuarioOk'), amount: '' });
  }

  function getSafeValue(StringValue) {
    StringValue = (StringValue || '') + '';
    StringValue = StringValue.replace(/"/g, '').replace(/\n/g, ' ');
    StringValue = `"${StringValue}"`;

    return StringValue;
  }

  function DownloadOrder() {
    if (orderData) {
      const detalle = orderData.detallePedido;
      const totales = orderData.totales;
      const csvHeader = [
        'Clave',
        'Cantidad',
        'Letra',
        'Precio',
        'Importe',
        'Status',
        'Descripción',
      ];
      let rows = [];
      rows.push([`Pedido #${orderData.folioPedido}`]);
      rows.push([`Kit: ${orderData.usuarioOk}`]);
      rows.push([' ']);
      rows.push(csvHeader);
      detalle.forEach((product) => {
        let productArray = [];
        productArray.push(getSafeValue(product.clave) || '');
        productArray.push(getSafeValue(product.cantidad) || '');
        productArray.push(getSafeValue(product.letra) || '');
        productArray.push(getSafeValue(product.precio) || '');
        productArray.push(getSafeValue(product.importe) || '');
        productArray.push(getSafeValue(product.status) || '');
        productArray.push(getSafeValue(product.descri) || '');
        rows.push(productArray);
      });
      rows.push([' ']);
      rows.push(['Subtotal:', totales.subtotal || '']);
      rows.push(['IVA:', totales.iva || '']);
      rows.push(['Total', totales.total || '']);
      rows.push(['Saldo actual:', totales.saldoActual || '']);
      rows.push(['Importe a pagar:', totales.importeAPagar || '']);
      let csvString = rows.map((e) => e.join(',')).join('\n');
      let universalBOM = '\uFEFF';
      let a = window.document.createElement('a');
      a.setAttribute(
        'href',
        'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString),
      );
      a.setAttribute('download', `Pedido-${orderData.folioPedido}.csv`);
      window.document.body.appendChild(a);
      a.click();
    } else {
      setAlertText('No hay pedio para descargar');
      setOpen(true);
    }
  }

  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      {orderMessage === 'error' && (
        <div className={styles.alertMessage}>
          <Collapse in={openMessage}>
            <AlertMessage
              severity='error'
              action={
                <div className={styles.closeContainer}>
                  <span
                    className={`material-icons-outlined ${styles.closeMessage}`}
                    onClick={() => {
                      setOpenMessage(false);
                    }}>
                    close
                  </span>
                </div>
              }
              sx={{ mb: 2 }}>
              The transaction could not be concluded successfully, please try again
            </AlertMessage>
          </Collapse>
        </div>
      )}
      <div className={`${styles.orderDetail}`}>
        <div className={styles.content}>
          <div className={styles.leftRow}>
            {getCookie('pedidoCerrado') === 'SI' && <OrderClose></OrderClose>}

            {screenSize !== 'phone' && (
              <OrderCard>
                <div className={styles.kitData}>
                  <div className={`${styles.kitName}`}>
                    <div className={styles.cardText}>{t('name')}:</div>
                    <div className={styles.num}>{getCookie('kitName')}</div>
                  </div>
                  <div className={`${styles.kitNumber}`}>
                    <div className={styles.cardText}>{t('kit')}:</div>
                    <div className={styles.num}>{getCookie('usuario')}</div>
                  </div>
                </div>

                <div className={styles.orderNum}>
                  <div className={styles.cardText}>{t('orderNumber')}:</div>
                  <div className={styles.num}>{getCookie('folioPedido')}</div>
                </div>
              </OrderCard>
            )}

            {screenSize === 'phone' && (
              <OrderCard>
                <div className={styles.orderNum}>
                  <div className={styles.cardText}>{t('orderNumber')}:</div>
                  <div className={styles.num}>{getCookie('folioPedido')}</div>
                </div>
              </OrderCard>
            )}

            <OrderCard>
              {(screenSize === 'phone' && (
                <div className={styles.sectionTitleProducts}>
                  <i className={`material-icons ${styles.sectionicon}`}>shopping_bag</i>
                  {t('products')}
                </div>
              )) || <div className={styles.sectionTitleBlue}>{t('products2')}</div>}

              <div className={styles.orderTable}>
                <OrderTable order={orderData} getOrder={getOrder} device={device} />
              </div>
            </OrderCard>

            {screenSize === 'phone' && (
              <div className={styles.orderTotals}>
                <OrderTotals
                  totals={orderData?.totales || []}
                  device={device || {}}
                  loading={loading}
                />
              </div>
            )}

            <div className={styles.sectionTitle}>
              <i className={`material-icons ${styles.sectionicon}`}>location_on</i>
              <div className={styles.sectiontext}>{t('customer')}</div>
            </div>

            <OrderCard>
              <div className={styles.shippingAddress}>
                <div className={styles.orderNum}>
                  <div className={styles.cardText}>
                    {((loading || loadingAddress) && (
                      <Skeleton
                        variant='rectangular'
                        animation='wave'
                        className={styles.loadingText}
                      />
                    )) || (
                      <>
                        {domicilioEnvio.domicilioClienteFinalSN === 'S'
                          ? domicilioEnvio.domicilioClienteFinalNombre ||
                            domicilioEnvio?.domicilioClienteFinalNombre ||
                            ''
                          : cliente.nombreCompleto || cliente?.nombreCompleto || ''}
                      </>
                    )}
                    :
                  </div>
                  <div className={styles.num}>
                    {((loading || loadingAddress) && (
                      <Skeleton
                        variant='rectangular'
                        animation='wave'
                        className={styles.loadingText}
                      />
                    )) || (
                      <>
                        {domicilioEnvio.domicilioClienteFinalSN === 'S'
                          ? domicilioEnvio.calle +
                              ' ' +
                              domicilioEnvio.colonia +
                              ' ' +
                              domicilioEnvio.municipio || ''
                          : cliente.calle + ' ' + cliente.colonia + ' ' + cliente.municipio || ''}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </OrderCard>

            <div className={styles.sectionTitle}>
              <i className={`material-icons ${styles.sectionicon}`}>location_on</i>
              <div className={styles.sectiontext}>{t('envio')}</div>
            </div>

            {changeAddress === 'false' && loading === false && (
              <OrderCard
                open={openAddress}
                callback={setOpenAddress}
                icon='edit'
                iconColor='gold'
                iconText={t('changeAddress')}
                iconSize={18}
                title={
                  <div className={styles.shippingAddress}>
                    <div className={styles.orderNum}>
                      <div className={styles.cardText}>
                        {((loading || loadingAddress) && (
                          <Skeleton
                            variant='rectangular'
                            animation='wave'
                            className={styles.loadingText}
                          />
                        )) || (
                          <>
                            {domicilioEnvio.domicilioClienteFinalSN === 'S'
                              ? domicilioEnvio.domicilioClienteFinalNombre || ''
                              : cliente?.nombreCompleto || ''}
                          </>
                        )}
                        :
                      </div>
                      <div className={styles.num}>
                        {((loading || loadingAddress) && (
                          <Skeleton
                            variant='rectangular'
                            animation='wave'
                            className={styles.loadingText}
                          />
                        )) ||
                          domicilioEnvio.calle +
                            ' ' +
                            domicilioEnvio.colonia +
                            ' ' +
                            domicilioEnvio.municipio ||
                          ''}
                      </div>
                    </div>
                  </div>
                }>
                <div className={styles.selectSavedAddresses}>
                  <SavedAddresses
                    history={history}
                    orderData={orderData}
                    setOrderData={setOrderData}
                    screenSize={screenSize}
                    getCookie={getCookie}
                    webservice={webservice}
                    getOrder={getOrder}
                    setOpenAddress={setOpenAddress}
                    setLoaddingAddress={setLoaddingAddress}
                    addressSelected={addressSelected}
                    setAddressSelected={setAddressSelected}
                    setSessionMessage={setSessionMessage}
                  />
                </div>
              </OrderCard>
            )}

            {changeAddress === 'true' && loading === false && (
              <OrderCard>
                <div className={styles.shippingAddress}>
                  <div className={styles.orderNum}>
                    <div className={styles.cardText}>
                      {((loading || loadingAddress) && (
                        <Skeleton
                          variant='rectangular'
                          animation='wave'
                          className={styles.loadingText}
                        />
                      )) || (
                        <>
                          {domicilioEnvio.domicilioClienteFinalSN === 'S'
                            ? domicilioEnvio.domicilioClienteFinalNombre || ''
                            : cliente?.nombreCompleto || ''}
                        </>
                      )}
                      :
                    </div>
                    <div className={styles.num}>
                      {((loading || loadingAddress) && (
                        <Skeleton
                          variant='rectangular'
                          animation='wave'
                          className={styles.loadingText}
                        />
                      )) ||
                        domicilioEnvio.calle +
                          ' ' +
                          domicilioEnvio.colonia +
                          ' ' +
                          domicilioEnvio.municipio ||
                        ''}
                    </div>
                  </div>
                </div>
              </OrderCard>
            )}

            {changeAddress === 'false' && loading === false && (
              <OrderCard title={t('addAnother')} open={false}>
                <div className={styles.formContainer}>
                  <AddressFormMX
                    setSessionMessage={setSessionMessage}
                    getCookie={getCookie}
                    history={history}
                    webservice={webservice}
                    device={device}
                    t={t}
                    callback={() => {
                      getOrder('CERRAR01', '', '', '', '', false, '');
                    }}
                  />
                </div>
              </OrderCard>
            )}

            {screenSize !== 'phone' && (
              <>
                <div className={styles.sectionTitle}>
                  <i className={`material-icons ${styles.sectionicon}`}>credit_card</i>
                  <div className={styles.sectiontext}>{t('pay')}</div>
                </div>

                <OrderCard>
                  <div>
                    <div className={styles.cardText}>
                      {!showPayment.cardPayment && (
                        <i
                          className={`material-icons ${styles.iconsRadio}`}
                          onClick={() => selectTypePayment('card')}>
                          radio_button_unchecked
                        </i>
                      )}

                      {showPayment.cardPayment && (
                        <i className={`material-icons ${styles.iconsRadioChecked}`}>
                          radio_button_checked
                        </i>
                      )}
                      <div className={styles.textCard}>{t('cards')}</div>
                      <div className={styles.iconsCard}>
                        <img
                          src={`https://webimages.terramarbrands.com.mx/webpage/visa.svg`}
                          alt=''
                          className={styles.imageCard}
                        />
                        &nbsp;
                        <img
                          src={`https://webimages.terramarbrands.com.mx/webpage/master-cart.svg`}
                          alt=''
                          className={styles.imageCard}
                        />
                      </div>
                    </div>

                    <div
                      className={!showPayment.cardPayment ? styles.payment : styles.paymentEnable}>
                      <div>&nbsp;</div>
                      <div className={styles.cardText}>
                        <div className={styles.inputsPayment}>
                          <label>Kit:</label>
                        </div>
                        <div>
                          <input
                            type='text'
                            className={styles.inputText}
                            name='kit'
                            value={form.kit}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>

                        <div className={styles.inputsPayment}>
                          <label>Monto:</label>
                        </div>
                        <div>
                          <input
                            type='text'
                            className={styles.inputText}
                            name='paytotal'
                            value={form.paytotal || ''}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      </div>
                      <div>&nbsp;</div>
                      <div className={styles.cardText}>
                        <div className={styles.inputsPaymentButtons}>
                          <Button
                            type='submit'
                            variant='contained'
                            size='large'
                            color='primary'
                            className={styles.buttonPaymentGold}
                            onClick={() => cancel()}>
                            {t('cancel')}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </OrderCard>

                <OrderCard>
                  <div className={styles.cardText}>
                    {!showPayment.paymentInStore && (
                      <i
                        className={`material-icons ${styles.iconsRadio}`}
                        onClick={() => selectTypePayment('paycash')}>
                        radio_button_unchecked
                      </i>
                    )}

                    {showPayment.paymentInStore && (
                      <i className={`material-icons ${styles.iconsRadioChecked}`}>
                        radio_button_checked
                      </i>
                    )}
                    <div className={styles.textCard}>{t('stores')}</div>
                    <img
                      src={`https://webimages.terramarbrands.com.mx/webpage/paycash.svg`}
                      alt=''
                      className={styles.image}
                    />
                  </div>
                </OrderCard>
                <OrderCard>
                  <div className={styles.cardText}>
                    {!showPayment.paymentInCash && (
                      <i
                        className={`material-icons ${styles.iconsRadio}`}
                        onClick={() => selectTypePayment('cash')}>
                        radio_button_unchecked
                      </i>
                    )}

                    {showPayment.paymentInCash && (
                      <i className={`material-icons ${styles.iconsRadioChecked}`}>
                        radio_button_checked
                      </i>
                    )}
                    <div className={styles.textCard}>{t('efectivo')}</div>
                    <img
                      src={`https://webimages.terramarbrands.com.mx/webpage/cash.svg`}
                      alt=''
                      className={styles.image}
                    />
                  </div>
                </OrderCard>
              </>
            )}

            <div className={styles.info}>
              <div className={styles.orderFooter}>
                <div className={styles.message}>
                  <div className={styles.blue}>{orderData?.mensaje || ''}</div>
                  {orderData?.situacionCierreMensaje && (
                    <div className={styles.alert}>
                      {t('closingStatus')}: {orderData.situacionCierreMensaje}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.rightRow}>
            {screenSize !== 'phone' && (
              <div className={styles.orderTotals}>
                <OrderTotals
                  totals={orderData?.totales || []}
                  device={device || {}}
                  loading={loading}
                />
              </div>
            )}

            {screenSize === 'phone' && (
              <>
                <div className={styles.sectionTitle}>
                  <i className={`material-icons ${styles.sectionicon}`}>credit_card</i>
                  <div className={styles.sectiontext}>{t('pay')}</div>
                </div>

                <OrderCard>
                  <div>
                    <div className={styles.cardText}>
                      {!showPayment.cardPayment && (
                        <i
                          className={`material-icons ${styles.iconsRadio}`}
                          onClick={() => selectTypePayment('card')}>
                          radio_button_unchecked
                        </i>
                      )}

                      {showPayment.cardPayment && (
                        <i className={`material-icons ${styles.iconsRadioChecked}`}>
                          radio_button_checked
                        </i>
                      )}
                      <div className={styles.textCard}>{t('cards')}</div>
                      <div className={styles.iconsCard}>
                        <img
                          src={`https://webimages.terramarbrands.com.mx/webpage/visa.svg`}
                          alt=''
                          className={styles.imageCard}
                        />
                        &nbsp;
                        <img
                          src={`https://webimages.terramarbrands.com.mx/webpage/master-cart.svg`}
                          alt=''
                          className={styles.imageCard}
                        />
                      </div>
                    </div>

                    <div
                      className={!showPayment.cardPayment ? styles.payment : styles.paymentEnable}>
                      <div>&nbsp;</div>
                      <div className={styles.cardText}>
                        <div className={styles.inputsPayment}>
                          <label>Kit:</label>
                        </div>
                        <div>
                          <input
                            type='text'
                            className={styles.inputText}
                            name='kit'
                            value={form.kit}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>

                        <div className={styles.inputsPayment}>
                          <label>Monto:</label>
                        </div>
                        <div>
                          <input
                            type='text'
                            className={styles.inputText}
                            name='paytotal'
                            value={form.paytotal || ''}
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      </div>
                      <div>&nbsp;</div>
                      <div className={styles.cardText}>
                        <div className={styles.inputsPaymentButtons}>
                          <Button
                            type='submit'
                            variant='contained'
                            size='large'
                            color='primary'
                            className={styles.buttonPaymentGold}
                            onClick={() => cancel()}>
                            Cancelar
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </OrderCard>

                <OrderCard>
                  <div className={styles.cardText}>
                    {!showPayment.paymentInStore && (
                      <i
                        className={`material-icons ${styles.iconsRadio}`}
                        onClick={() => selectTypePayment('paycash')}>
                        radio_button_unchecked
                      </i>
                    )}

                    {showPayment.paymentInStore && (
                      <i className={`material-icons ${styles.iconsRadioChecked}`}>
                        radio_button_checked
                      </i>
                    )}
                    <div className={styles.textCard}>{t('stores')}</div>
                    <img
                      src={`https://webimages.terramarbrands.com.mx/webpage/paycash.svg`}
                      alt=''
                      className={styles.image}
                    />
                  </div>
                </OrderCard>
                <OrderCard>
                  <div className={styles.cardText}>
                    {!showPayment.paymentInCash && (
                      <i
                        className={`material-icons ${styles.iconsRadio}`}
                        onClick={() => selectTypePayment('cash')}>
                        radio_button_unchecked
                      </i>
                    )}

                    {showPayment.paymentInCash && (
                      <i className={`material-icons ${styles.iconsRadioChecked}`}>
                        radio_button_checked
                      </i>
                    )}
                    <div className={styles.textCard}>Efectivo (déposito o transferencia)</div>
                    <img
                      src={`https://webimages.terramarbrands.com.mx/webpage/cash.svg`}
                      alt=''
                      className={styles.image}
                    />
                  </div>
                </OrderCard>
              </>
            )}

            {changePaq === 'false' && loading === false && (
              <OrderCard>
                <div className={styles.orderDet}>
                  <div className={styles.cardTextPaq}>
                    <div className={styles.textIcon}>
                      <i className={`material-icons ${styles.icon}`}>local_shipping </i>
                      <label className={styles.iconText}>{t('shipping')}</label>
                    </div>
                  </div>
                  <div className={styles.options}>
                    {getCookie('pedidoCerrado') === 'SI' ? (
                      <select
                        className={styles.inputSelect}
                        onChange={(e) => changeValue(e)}
                        value={paqueteria}
                        disabled='disabled'>
                        <option value=''>{t('shipping2')}</option>
                        {paqueterias.length > 0 &&
                          paqueterias.map((val, key) => {
                            return (
                              <option key={key} value={val.paqueteria}>
                                {val.paqueteria} ({val.precio})
                              </option>
                            );
                          })}
                      </select>
                    ) : (
                      <select
                        className={styles.inputSelect}
                        onChange={(e) => changeValue(e)}
                        value={paqueteria}>
                        <option value=''>{t('shipping2')}</option>
                        {paqueterias.length > 0 &&
                          paqueterias.map((val, key) => {
                            return (
                              <option key={key} value={val.paqueteria}>
                                {val.paqueteria} ({val.precio})
                              </option>
                            );
                          })}
                      </select>
                    )}
                  </div>
                </div>
              </OrderCard>
            )}

            {changePaq === 'false' && loading === true && (
              <OrderCard>
                <div className={styles.orderDet}>
                  <div className={styles.cardTextPaq}>
                    <div className={styles.textIcon}>
                      <i className={`material-icons ${styles.icon}`}>local_shipping </i>
                      <label className={styles.iconText}>{t('loadShipping')}</label>
                    </div>
                  </div>
                </div>
              </OrderCard>
            )}

            {getCookie('warehouse') !== '02' && (
              <OrderCard>
                <div className={styles.orderDet}>
                  <div className={styles.cardText}>
                    <div className={styles.textIcon}>
                      <i className={`material-icons ${styles.icongreen}`}>spa </i>
                      <label className={styles.textTerra}>&nbsp;{t('greenBag')}</label>

                      {greenBag === true && (
                        <i
                          className={`material-icons ${styles.iconsRadio}`}
                          onClick={() => greenBagSelect()}>
                          check_box
                        </i>
                      )}
                      {greenBag === false && (
                        <i
                          className={`material-icons ${styles.iconsRadio}`}
                          onClick={() => greenBagSelect()}>
                          check_box_outline_blank
                        </i>
                      )}
                    </div>
                  </div>
                </div>
              </OrderCard>
            )}

            {screenSize !== 'phone' && (
              <div className={styles.accionButton}>
                <Button
                  type='submit'
                  variant='contained'
                  size='large'
                  color='primary'
                  className={
                    (orderData.situacionCierre !== 'LISTO' && styles.disabled) || styles.button
                  }
                  onClick={() => {
                    if (finishLoading) return;
                    else handleClick();
                  }}
                  disabled={orderData.situacionCierre !== 'LISTO'}>
                  {t('payNow')}
                  {(finishLoading && <CircularProgress className={styles.finichLoading} />) || (
                    <i className={`material-icons ${styles.buttonIcon}`}>trending_flat</i>
                  )}
                </Button>
                <div className={styles.termsAlert}>{t('termsAlert')}</div>
                <div className={styles.dowloadOrder} onClick={() => DownloadOrder()}>
                  <i className={`material-icons ${styles.dowloadIcon}`}>file_download</i>
                  <label className={styles.line}>{t('download')}</label>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {screenSize === 'phone' && (
        <div className={styles.accionButton}>
          <div className={styles.termsAlertMobil}>
            <div className={styles.footerTotal}>
              <div className={styles.footerTotalLeft}>{t('saldo')}&nbsp;</div>
              <div className={styles.footerTotalRigth}>${totales.importeAPagar}</div>
            </div>
            {t('termsAlert')}
          </div>
          <Button
            type='submit'
            variant='contained'
            size='large'
            color='primary'
            className={(orderData.situacionCierre !== 'LISTO' && styles.disabled) || styles.button}
            onClick={handleClick}
            disabled={orderData.situacionCierre !== 'LISTO'}>
            {t('payNow')}
            {(finishLoading && <CircularProgress className={styles.finichLoading} />) || (
              <i className={`material-icons ${styles.buttonIcon}`}>trending_flat</i>
            )}
          </Button>
          <div className={styles.dowloadOrderMobile} onClick={() => DownloadOrder()}>
            <i className={`material-icons ${styles.dowloadIcon}`}>file_download</i>
            <label className={styles.line}>{t('download')}</label>
          </div>
        </div>
      )}
    </div>
  );
}
